import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import {
  DealPayrollGroupSettings,
  DealPayrollGroupSettingsRequest,
  DealPayrollRates,
  DealPayrollRatesRequest,
  UserPayrollSettingsRequest, UserPayrollSettingsResumeRequest,
  UserPayrollSettingsResponse
} from '../models/deal-payroll.model';
import {ApiConnectService} from './api-connect.service';
import {ReportService} from './report.service';
import {
  DEAL_PAYROLL_GROUP_SETTINGS_PATH,
  USER_PAYROLL_SETTINGS_PATH, USER_PAYROLL_SETTINGS_RESUME_PATH
} from './deal-payroll-settings.service.constants';

@Injectable()
export class DealPayrollSettingsService {
  constructor(private http: HttpClient, private api: ApiConnectService, private reportService: ReportService) {}

  getPayrollCalculationSettings(userId: string): Observable<UserPayrollSettingsResponse> {
    return this.http.get<UserPayrollSettingsResponse>(
      this.api.dealPayrollUserSettings + userId + USER_PAYROLL_SETTINGS_PATH
    );
  }

  updatePayrollCalculationSettings(
    userId: string,
    request: UserPayrollSettingsRequest
  ): Observable<UserPayrollSettingsResponse> {
    return this.http.put<UserPayrollSettingsResponse>(
      this.api.dealPayrollUserSettings + userId + USER_PAYROLL_SETTINGS_PATH,
      request
    ).do(() => this.reportService.invalidatePayrollReports());
  }

  resumePayrollCalculationSettings(
    userId: string, request: UserPayrollSettingsResumeRequest
  ): Observable<UserPayrollSettingsResponse> {
    return this.http.post<UserPayrollSettingsResponse>(
      this.api.dealPayrollUserSettings + userId + USER_PAYROLL_SETTINGS_PATH + USER_PAYROLL_SETTINGS_RESUME_PATH, request)
      .do(() => this.reportService.invalidatePayrollReports());
  }

  getDealPayrollGroupSettings(groupId: string): Observable<DealPayrollGroupSettings> {
    return this.http.get<DealPayrollGroupSettings>(
      this.api.dealPayrollGroup + groupId + DEAL_PAYROLL_GROUP_SETTINGS_PATH
    );
  }

  updateDealPayrollGroupSettings(
    groupId: string,
    request: DealPayrollGroupSettingsRequest
  ): Observable<DealPayrollGroupSettings> {
    return this.http.put<DealPayrollGroupSettings>(
      this.api.dealPayrollGroup + groupId + DEAL_PAYROLL_GROUP_SETTINGS_PATH,
      request
    ).do(() => this.reportService.invalidatePayrollReports());
  }

  getDealPayrollCatalog(): Observable<DealPayrollGroupSettings[]> {
    return this.http.get<DealPayrollGroupSettings[]>(this.api.dealPayrollCatalog);
  }

  getDealPayrollRates(): Observable<DealPayrollRates> {
    return this.http.get<DealPayrollRates>(this.api.dealPayrollRates);
  }

  updateDealPayrollRates(request: DealPayrollRatesRequest): Observable<DealPayrollRates> {
    return this.http.put<DealPayrollRates>(this.api.dealPayrollRates, request)
      .do(() => this.reportService.invalidatePayrollReports());
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/deal-payroll-settings.service.ts